import { Grid } from "@mui/material";

export function Insom() {
  return <Grid></Grid>;
}
